$(document).ready(function () {
     $(document).on('mouseenter','.mega-menu__linklist li',function () {
    var li_index = $(this).data('index');
      $(this).addClass('active').siblings().removeClass('active');    
      $(this).parents('.mega-menu__linklist').siblings('.menu_right_show').find(`.tabcontent[data-index="${li_index}"]`).addClass('sractive').siblings().removeClass('sractive');
  });
  $('.add').parent('li').addClass('plusmen');
  $('.plusmen').click(function(){
  $(this).toggleClass("is");
  $('.ul_same').toggleClass("add");
});
});

$(document).on("touchstart", ".custom-Sidebar-Menu li.SideMenu_SubMenu_List , .header__primary-nav button[aria-controls=sidebar-menu] , .header-sidebar__scroller section.mens_women_collection_home_03 .swiper-slide , .sub_nested_menu_open .sub_menu_active , .custom-bootom-nav .customss .sub-group-submenu , .sub_nested_menu_open ul.sub_nested_first_step .Sub_group_nestmenu, .langify_language_changes.active , .hamburger_slider .custom_01_3", function () { $(this).addClass("touch-active"); });
$(document).on("touchend", ".custom-Sidebar-Menu li.SideMenu_SubMenu_List , .header__primary-nav button[aria-controls=sidebar-menu] , .header-sidebar__scroller section.mens_women_collection_home_03 .swiper-slide , .sub_nested_menu_open .sub_menu_active , .custom-bootom-nav .customss .sub-group-submenu , .sub_nested_menu_open ul.sub_nested_first_step .Sub_group_nestmenu, .langify_language_changes.active , .hamburger_slider .custom_01_3", function () {
    setTimeout(() => {  $(this).removeClass("touch-active");  }, 300); });
$(document).ready(function(){
var offsetFromTop = 0; 
var previousOffsetFromTop = 0; 
document.querySelector('.header-sidebar__scroller').addEventListener('scroll', function(event) {
    previousOffsetFromTop = offsetFromTop; 
    offsetFromTop = event.target.scrollTop; 
});
$(document).on('click' , '.Sub_group_SubMenu.sub_nested_menu'  , function () {
  $(this).parents('.SideMenu_SubMenu_List').find('.nestmenu_ul .image_navigation_val').fadeIn();
  $(this).parents('.SideMenu_SubMenu_List').find('.nestmenu_ul .sub_nested__active_first').fadeIn();
    $(this).parents('.SideMenu_SubMenu_List').find('.nestmenu_ul .sub_nested_first_step').fadeIn();  
   $(this).parents('.SideMenu_SubMenu_List').find('.nestmenu_ul .nested_meny_subdata').css('display' , 'flex');
  $(this).parents('.header-sidebar__scroller').addClass('sub_nested_menu_open');
  $('.sub_nested_menu_open').scrollTop(0);
   $(this).parents('.SideMenu_SubMenu_List').addClass('open_nested_menu');
  $('li#humburger_slider').css('opacity', '0');
});
$(document).on('click' , '.sub_nested__active_first', function () { 
  $(this).parents('.SideMenu_SubMenu_List').find('.nestmenu_ul .image_navigation_val').fadeOut();
  $(this).parents('.SideMenu_SubMenu_List').find('.nestmenu_ul .sub_nested__active_first').fadeOut();
    $(this).parents('.SideMenu_SubMenu_List').find('.nestmenu_ul .sub_nested_first_step').fadeOut();
  $(this).parents('.SideMenu_SubMenu_List').find('.nestmenu_ul .nested_meny_subdata').fadeOut();
  $(this).parents('.header-sidebar__scroller').removeClass('sub_nested_menu_open');
   $(this).parents('.SideMenu_SubMenu_List').removeClass('open_nested_menu');
  $('.header-sidebar__scroller').scrollTop(previousOffsetFromTop);
  $('li#humburger_slider').animate({ opacity: 1 }, 300);
});
$(document).on('click' , '.nested_child .Sub_group_nestmenu svg'  , function () {
  $(this).parents('.nestmenu_ul').addClass('nested_child_me');
  $(this).parents('.header-sidebar__scroller').addClass('sub_child_nested_menu_open');
  $(this).parents('li.nestmenu_list.nested_child').addClass('open_child_nested_menu');
});
$(document).on('click' , '.sub_child_menu_active.sub_child_active_first'  , function () {
  $(this).parents('.nestmenu_ul').removeClass('nested_child_me');
  $(this).parents('.header-sidebar__scroller').removeClass('sub_child_nested_menu_open');
  $(this).parents('li.nestmenu_list.nested_child').removeClass('open_child_nested_menu');
});

$(document).on('click', '.header__primary-nav button[aria-expanded="true"]', function() {  
$('.open_nested_menu, .sub_child_nested_menu_open, .open_child_nested_menu, .sub_nested_menu_open , .nested_child_me ').removeClass('open_nested_menu sub_child_nested_menu_open open_child_nested_menu sub_nested_menu_open nested_child_me ');
   $(this).parents('.SideMenu_SubMenu_List').find('.nestmenu_ul .image_navigation_val').fadeIn();
  $(this).parents('.SideMenu_SubMenu_List').find('.nestmenu_ul .sub_nested__active_first').fadeIn();
    $(this).parents('.SideMenu_SubMenu_List').find('.nestmenu_ul .sub_nested_first_step').fadeIn();
  // $(this).parents('.SideMenu_SubMenu_List').find('.nestmenu_ul .nested_menu_ul_structure').fadeIn();
});  

  setTimeout(() => {
  var $currencySwitchers_headermenu = $('.hn-bottom-localize .doubly-wrapper .doubly-nice-select.currency-switcher');
var $currencySelecter_headermenu = $('.hn-bottom-localize  .doubly-wrapper select.currency-switcher');
console.log($currencySwitchers_headermenu.length);
console.log($currencySelecter_headermenu.length);
if ($currencySwitchers_headermenu.length === 2 || $currencySelecter_headermenu === 2) {
  $currencySwitchers_headermenu.eq(1).remove(); 
    $currencySelecter_headermenu.eq(1).remove(); 
}
}, 1000);
// add to cart animation
  $(document).on('click', '.bottom-button-section .bottom-button', function () {
    $(this).addClass('animation_load');
});
});


